import styled, { keyframes } from 'styled-components';

import { RATE_IT_TIERS } from '../constants';

const riseIn = keyframes`
  from { opacity: 0; transform: translate(-50%, 8px); }
  to   { opacity: 1; transform: translate(-50%, 0); }
`;

const Toast = styled.div`
  position: absolute;
  left: 50%;
  /* Above the bottom band, so the confirmation never covers the tile that produced it. */
  bottom: 168px;
  transform: translateX(-50%);
  z-index: 20;
  padding: 8px 18px;
  border-radius: 999px;
  background: rgba(10, 10, 12, 0.88);
  border: 1px solid ${(props) => props.$col};
  color: ${(props) => props.$col};
  font-family: CeraPro, sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.4px;
  pointer-events: none;
  animation: ${riseIn} 160ms ease-out;
  white-space: nowrap;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

/**
 * Confirms a rating by naming the tier the fan picked — the brief's "toast appears".
 *
 * A local component rather than the app-wide `HANDLE_RES` / `ErrRes` mechanism, deliberately.
 * `ErrRes` is a fixed top-right panel on a light ground with a ~6s life; this has to be
 * tier-coloured, brief (shorter than the auto-advance dwell, or it would outlive the moment it
 * describes), and positioned over the media it belongs to. Errors still go through `HANDLE_RES`.
 */
const RateItRatingToast = ({ rating }) => {
  const tier = RATE_IT_TIERS.find((t) => t.id === rating);
  if (!tier) return null;

  return (
    <Toast role="status" $col={tier.labelColor}>
      {tier.label}
    </Toast>
  );
};

export default RateItRatingToast;
